import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(VRow,{staticClass:"mt-10",attrs:{"align":"center","justify":"center"}},[_c(VCol,{attrs:{"cols":"4"}},[_c('img',{attrs:{"width":500,"src":require("./../assets/logo.png")}})])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }